exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3uE8_B1aeukNROOUvHBvVx .ms-DatePicker-event--without-label,._3uE8_B1aeukNROOUvHBvVx input{color:\"[theme:neutralTertiary, default:#a6a6a6]\"}html[dir] ._1JFy1b9decfF9TYLD9G2L3 .ms-TextField-fieldGroup{background-color:transparent}", ""]);

// exports
exports.locals = {
	"grey": "_3uE8_B1aeukNROOUvHBvVx",
	"datepickerInput": "_1JFy1b9decfF9TYLD9G2L3"
};